import * as R from 'ramda';

import genericAsset from '@atom/components/common/svgIcons/genericAsset.svg';
import genericAssetActive from '@atom/components/common/svgIcons/genericAssetActive.svg';
import kmlLineBlue from '@atom/components/common/svgIcons/kmlLineBlue.svg';
import kmlLineRed from '@atom/components/common/svgIcons/kmlLineRed.svg';
import kmlLineYellow from '@atom/components/common/svgIcons/kmlLineYellow.svg';
import kmlMilePostBlueInactive from '@atom/components/common/svgIcons/kmlMilePostBlueInactive.svg';
import kmlShapePurple from '@atom/components/common/svgIcons/kmlShapePurple.svg';
import kmlShapeRed from '@atom/components/common/svgIcons/kmlShapeRed.svg';
import kmlVehicleBlue from '@atom/components/common/svgIcons/kmlVehicleBlue.svg';
import kmlVehicleGray from '@atom/components/common/svgIcons/kmlVehicleGray.svg';
import user from '@atom/components/common/svgIcons/user.svg';
import userActive from '@atom/components/common/svgIcons/userActive.svg';
import workOrderAssigned from '@atom/components/common/svgIcons/workOrderAssigned.svg';
import workOrderAssignedActive from '@atom/components/common/svgIcons/workOrderAssignedActive.svg';
import workOrderClosed from '@atom/components/common/svgIcons/workOrderClosed.svg';
import workOrderClosedActive from '@atom/components/common/svgIcons/workOrderClosedActive.svg';
import workOrderCompleted from '@atom/components/common/svgIcons/workOrderCompleted.svg';
import workOrderCompletedActive from '@atom/components/common/svgIcons/workOrderCompletedActive.svg';
import workOrderInProgress from '@atom/components/common/svgIcons/workOrderInProgress.svg';
import workOrderInProgressActive from '@atom/components/common/svgIcons/workOrderInProgressActive.svg';
import workOrderInReview from '@atom/components/common/svgIcons/workOrderInReview.svg';
import workOrderInReviewActive from '@atom/components/common/svgIcons/workOrderInReviewActive.svg';
import workOrderRequested from '@atom/components/common/svgIcons/workOrderRequested.svg';
import workOrderRequestedActive from '@atom/components/common/svgIcons/workOrderRequestedActive.svg';
import workOrderUnassigned from '@atom/components/common/svgIcons/workOrderUnassigned.svg';
import workOrderUnassignedActive from '@atom/components/common/svgIcons/workOrderUnassignedActive.svg';
import {
  activeAssetMarkers,
  assetMarkers,
} from '@atom/constants/markerIconConstants';
import naturalSort from '@atom/utilities/naturalSortCollator';

// Key matches the markerId
export const kmlMarkers = {
  0: kmlVehicleBlue,
  1: kmlVehicleGray,
  2: kmlShapePurple,
  3: kmlLineBlue,
  4: kmlShapeRed,
  5: kmlLineRed,
  6: kmlLineYellow,
  7: kmlMilePostBlueInactive,
};

const getInactiveAssetIconFromSchemaMarkerId = markerId => {
  return assetMarkers[markerId] || genericAsset;
};

// Produces an ordered list of schema icons to be used in the UI
export const getSchemaIconsList = () => {
  return R.sort(naturalSort, R.map(String, R.keys(assetMarkers))).map(
    key => assetMarkers[key],
  );
};

const getActiveAssetIconFromSchemaMarkerId = markerId => {
  return activeAssetMarkers[markerId] || genericAssetActive;
};

const getWorkOrderSvg = (status: any, isActive: boolean) => {
  const inactiveSvgIcons = [
    workOrderRequested,
    workOrderUnassigned,
    workOrderAssigned,
    workOrderInProgress,
    workOrderCompleted,
    workOrderClosed,
    workOrderInReview,
  ];

  const activeSvgIcons = [
    workOrderRequestedActive,
    workOrderUnassignedActive,
    workOrderAssignedActive,
    workOrderInProgressActive,
    workOrderCompletedActive,
    workOrderClosedActive,
    workOrderInReviewActive,
  ];

  return isActive
    ? status >= activeSvgIcons.length
      ? activeSvgIcons[0]
      : activeSvgIcons[status]
    : status >= inactiveSvgIcons.length
      ? inactiveSvgIcons[0]
      : inactiveSvgIcons[status];
};

const getUserSvg = (isActive: boolean) => (isActive ? userActive : user);

const getKmlSvg = (markerId: number) => kmlMarkers[markerId] || null;

const markerUtilities = {
  getActiveAssetIconFromSchemaMarkerId,
  getInactiveAssetIconFromSchemaMarkerId,
  getWorkOrderSvg,
  getUserSvg,
  getKmlSvg,
};

export default markerUtilities;
